export interface Movie {
  id: number;
  title: string;
  poster: string;
  backdrop: string;
  rating: number;
  year: number;
  genre: string[];
  description: string;
  director: string;
  cast: string[];
  duration: number;
  maturityRating: string;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: "Cosmic Horizon",
    poster: "https://images.unsplash.com/photo-1576814093277-6c3f3b775cfe?w=400&h=600&fit=crop",
    backdrop: "https://images.unsplash.com/photo-1576814093277-6c3f3b775cfe?w=1200&h=400&fit=crop",
    rating: 8.5,
    year: 2024,
    genre: ["Sci-Fi", "Adventure"],
    description: "A thrilling journey through space exploring distant galaxies and alien civilizations.",
    director: "James Chen",
    cast: ["Chris Hemsworth", "Zendaya", "Oscar Isaac"],
    duration: 148,
    maturityRating: "PG-13",
  },
  {
    id: 2,
    title: "Echoes of Tomorrow",
    poster: "https://images.unsplash.com/photo-1489599849228-58d7an4bddab?w=400&h=600&fit=crop",
    backdrop: "https://images.unsplash.com/photo-1489599849228-58d7an4bddab?w=1200&h=400&fit=crop",
    rating: 8.2,
    year: 2023,
    genre: ["Drama", "Thriller"],
    description: "A mind-bending psychological thriller about memory, identity, and reality.",
    director: "Nolan-inspired Director",
    cast: ["Timothée Chalamet", "Florence Pugh", "Robert Pattinson"],
    duration: 156,
    maturityRating: "R",
  },
  {
    id: 3,
    title: "Lost in Paradise",
    poster: "https://images.unsplash.com/photo-1535823245-1ba22f6b5ff1?w=400&h=600&fit=crop",
    backdrop: "https://images.unsplash.com/photo-1535823245-1ba22f6b5ff1?w=1200&h=400&fit=crop",
    rating: 7.8,
    year: 2024,
    genre: ["Romance", "Adventure"],
    description: "Two strangers meet on a tropical island and discover love in unexpected places.",
    director: "Sofia Coppola",
    cast: ["Margot Robbie", "Ryan Gosling", "Anya Taylor-Joy"],
    duration: 124,
    maturityRating: "PG",
  },
  {
    id: 4,
    title: "The Last Guardian",
    poster: "https://images.unsplash.com/photo-1486882735611-87f7c33d4dfe?w=400&h=600&fit=crop",
    backdrop: "https://images.unsplash.com/photo-1486882735611-87f7c33d4dfe?w=1200&h=400&fit=crop",
    rating: 8.7,
    year: 2023,
    genre: ["Action", "Fantasy"],
    description: "An epic fantasy adventure where a lone warrior must protect humanity's last hope.",
    director: "Peter Jackson-style Director",
    cast: ["Henry Cavill", "Gal Gadot", "Jason Momoa"],
    duration: 165,
    maturityRating: "PG-13",
  },
  {
    id: 5,
    title: "Midnight Secrets",
    poster: "https://images.unsplash.com/photo-1536440936999-e100046f311d?w=400&h=600&fit=crop",
    backdrop: "https://images.unsplash.com/photo-1536440936999-e100046f311d?w=1200&h=400&fit=crop",
    rating: 7.5,
    year: 2024,
    genre: ["Mystery", "Thriller"],
    description: "A detective uncovers dark secrets in a small town where nothing is what it seems.",
    director: "Denis Villeneuve",
    cast: ["Ryan Reynolds", "Blake Lively", "Tom Hardy"],
    duration: 132,
    maturityRating: "R",
  },
  {
    id: 6,
    title: "Neon Dreams",
    poster: "https://images.unsplash.com/photo-1552820728-8ac41f1ce891?w=400&h=600&fit=crop",
    backdrop: "https://images.unsplash.com/photo-1552820728-8ac41f1ce891?w=1200&h=400&fit=crop",
    rating: 8.1,
    year: 2023,
    genre: ["Sci-Fi", "Thriller"],
    description: "In a cyberpunk future, a hacker discovers a conspiracy that could change everything.",
    director: "Rian Johnson",
    cast: ["Keanu Reeves", "Charlize Theron", "Tom Cruise"],
    duration: 138,
    maturityRating: "R",
  },
  {
    id: 7,
    title: "The Last Dance",
    poster: "https://images.unsplash.com/photo-1478720568477-152d9e3fb27f?w=400&h=600&fit=crop",
    backdrop: "https://images.unsplash.com/photo-1478720568477-152d9e3fb27f?w=1200&h=400&fit=crop",
    rating: 8.3,
    year: 2024,
    genre: ["Drama", "Romance"],
    description: "A touching story about love, loss, and the power of dance to heal.",
    director: "Greta Gerwig",
    cast: ["Saoirse Ronan", "Timothée Chalamet", "Laura Dern"],
    duration: 125,
    maturityRating: "PG",
  },
  {
    id: 8,
    title: "Shadow Protocol",
    poster: "https://images.unsplash.com/photo-1478720568477-152d9e3fb27f?w=400&h=600&fit=crop",
    backdrop: "https://images.unsplash.com/photo-1478720568477-152d9e3fb27f?w=1200&h=400&fit=crop",
    rating: 8.4,
    year: 2023,
    genre: ["Action", "Thriller"],
    description: "A former spy is pulled back into the world of espionage for one last mission.",
    director: "Doug Liman",
    cast: ["Tom Cruise", "Rebecca Ferguson", "Jeremy Renner"],
    duration: 145,
    maturityRating: "PG-13",
  },
];

export const genres = ["All", "Action", "Drama", "Sci-Fi", "Romance", "Thriller", "Adventure", "Fantasy", "Mystery"];
